"use client"

import { useState } from "react"
import { AiAssistantSidebar } from "@/components/ai-assistant-sidebar"
import { ComponentPalette } from "@/components/component-palette"
import { VisualizerCanvas } from "@/components/visualizer-canvas"
import { PropertiesPanel } from "@/components/properties-panel"
import { SchemaHistoryDropdown } from "@/components/schema-history-dropdown"
import { useVisualizer, VisualizerProvider } from "@/lib/visualizer-context"
import { ArrowBigLeft } from "lucide-react"
export interface FormBuilderPageProps {
	document_classifier: {
		id: number
		extraction_schema: Record<string, any>
	}
}

function FormBuilderPage({document_classifier}: FormBuilderPageProps) {
	console.log(document_classifier)
	const { dataSchema, visualizerConfig, data, setVisualizerConfig, setDataSchema } = useVisualizer()

	const [selectedElement, setSelectedElement] = useState<any>(null)
	const [aiSidebarOpen, setAiSidebarOpen] = useState(false)

	//
	//

	const handleElementUpdate = (updated: any) => {
		if (!updated || !updated.path || updated.tabIndex === undefined) return

		try {
			const { path, tabIndex, ...elementData } = updated
			const newConfig = JSON.parse(JSON.stringify(visualizerConfig))
			const tab = newConfig.tabs[tabIndex]

			// Navigate to the element and update it
			let current = tab.layout
			for (let i = 0; i < path.length - 1; i++) {
				if (Array.isArray(current[path[i]])) {
					current = current[path[i]]
				} else {
					current = current[path[i]].children || []
				}
			}

			current[path[path.length - 1]] = elementData

			setVisualizerConfig(newConfig)
			setSelectedElement(updated)
		} catch (error) {
			console.error("Error updating element:", error)
		}
	}

	const getSelectedElementData = () => {
		if (!selectedElement || !selectedElement.path || selectedElement.tabIndex === undefined) return null

		try {
			const { path, tabIndex } = selectedElement
			const tab = visualizerConfig.tabs[tabIndex]
			let current = tab.layout

			for (let i = 0; i < path.length - 1; i++) {
				if (Array.isArray(current[path[i]])) {
					current = current[path[i]]
				} else {
					current = current[path[i]].children || []
				}
			}

			return {
				...current[path[path.length - 1]],
				path,
				tabIndex,
			}
		} catch {
			return null
		}
	}

	const selectedElementData = getSelectedElementData()

	const handleConfigChange = (newConfig: any) => {


		setVisualizerConfig(newConfig)

	}

	return (
		<div className="h-screen flex flex-col bg-background">
			<div className="border-b px-4 py-2 flex items-center justify-between">

				<ArrowBigLeft className="mr-4 cursor-pointer" onClick={() => window.history.back()} />
				<h1 className="text-lg font-semibold">Form Builder</h1>
				<SchemaHistoryDropdown />
			</div>

			<div className="flex-1 flex overflow-hidden">
				<ComponentPalette />

				<div className="flex-1 flex flex-col">
					<VisualizerCanvas
						config={visualizerConfig}
						dataSchema={dataSchema}
						data={data}
						document_classifier_id={document_classifier.id}
						onConfigChange={handleConfigChange}
						onSchemaChange={setDataSchema}
						onElementSelect={setSelectedElement}
						selectedElement={selectedElement}
					/>
				</div>

				{selectedElementData ? (
					<PropertiesPanel
						element={selectedElementData}
						dataSchema={dataSchema}
						onElementUpdate={handleElementUpdate}
					/>
				) : (
					<AiAssistantSidebar isOpen={aiSidebarOpen} onToggle={() => setAiSidebarOpen(!aiSidebarOpen)} />
				)}
			</div>
		</div>
	)
}

FormBuilderPage.layout = (page: any) => {
	return (
		<VisualizerProvider config={page?.props.config} data={page?.props.data} document_classifier={page?.props.document_classifier}>
			{page}
		</VisualizerProvider>
	)
}

export default FormBuilderPage
